import { useEffect, useState } from "react";
import { DISABLE_VENDOR, FETCH_ALL_VENDERS_BY_MID, FETCH_VENDER_DETAILS_BY_VENDER_ID, FETCH_VENDER_OLD_ACCOUNTS_DETAILS_BY_VENDER_ID } from "../../Utils/Constants";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useApiServices from "../../Utils/useApiService";
import Modal from "../../Common/Modal/Modal";
import RegisterVendor from "./RegisterVendor";
import styles from "./ArchieveReport.module.css";
import CheckExportConst from "../../Utils/PrivilagesUtilityFun/CheckExportConst";
import ViewVendor from "./ViewVendor";
import NoDataFound from "../../Common/NoDataFound/NoDataFound";
import { Switch, Tooltip } from "@mui/material";
import swal from 'sweetalert';
import { useSelector } from "react-redux";
import IconWrapper from "../../Common/IconWrapper/IconWrapper";
import ViewVendorBankDetails from "./ViewVendorAccounts";
import EditVendorBankDetails from "./EditVendorBankDetails";
import EditVendorMobile from "./EditVendorMobile";

/**
 * @returns {ReactNode} - This component renders vendors list and also the 
 */

const SubmittedVendor = () => {
  const [venderData, setVenderData] = useState([]);
  const [callAgain, setCallAgain] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const { mid } = useSelector((state) => state.userData);
  // EDIT VENDOR STATES 
  const [editVendorData, setEditVendorData] = useState({});

  // VIEW STATES 
  const [vendorBankData, setVendorBankData] = useState([]);
  const [viewData, setViewData] = useState({
    accountNumber: "",
    bankName: "",
    branchName: "",
    category: "",
    email: "",
    fullName: "",
    ifscCode: "",
    mobile: "",
    parentMid: "",
    updateDate: "",
    upi: "",
    vendorId: "",
    vendorStatus: "",
  });


  const { apiCallFnforGet, apiCallFnforPut } = useApiServices();

  const VenderByStatusWithMid = async () => {
    try {
      let url = "";

      url = `${FETCH_ALL_VENDERS_BY_MID}${mid}`;
      const response = await apiCallFnforGet(url);
      const data = response?.data || [];

      const updatedData = data.map((entry) => ({
        ...entry,
        id: entry?.vendorId,
        viewDetails: (
          <button
            className="btn btn-sm btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#ViewVendor"
            onClick={() => fetchVenderByVenderId(entry?.vendorId)}
          >
            View Details
          </button>
        ),
      }));

      setVenderData(updatedData);
    } catch (error) {
      console.log(`Error while fetching Vendors By MID: ${error}`);
    }
  };

  useEffect(() => {
    VenderByStatusWithMid();
  }, [callAgain]);

  const fetchVenderByVenderId = async (vendorId) => {
    if (!vendorId) {
      return;
    }
    try {
      setVendorId(vendorId);
      let res = await apiCallFnforGet(
        FETCH_VENDER_DETAILS_BY_VENDER_ID + vendorId
      );
      setViewData(res?.data);
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  const fetchVendorAccountInfo = async (vendorId) => {
    if (!vendorId) {
      return;
    }
    try {
      setVendorId(vendorId);
      let res = await apiCallFnforGet(
        FETCH_VENDER_OLD_ACCOUNTS_DETAILS_BY_VENDER_ID + vendorId
      );
      // ✅ Add a unique id to each row
      const rowsWithId = res?.data?.map((item, index) => ({
        id: index + 1, // or use some unique field from item if available
        ...item,
      }));

      setVendorBankData(rowsWithId);
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  const handleDisableVendor = async (vendorId, enableStatus) => {
    if (!vendorId) {
      swal("Error", "Failed to Disable Vender", "error");
      return;
    }
    // Final API call
    try {
      const response = await apiCallFnforPut(`${DISABLE_VENDOR}${vendorId}/status?enabled=${enableStatus}`);
      if (response?.statusCode === 200) {
        swal("Success", "Vender Disable Successfully", "success");
        const closeBtn = document.getElementById("close-btn");
        if (closeBtn) {
          closeBtn.click();
        }
        VenderByStatusWithMid();
      } else {
        swal("Error", response?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Submission error:", error);
      swal("Error", "Failed to Disable Vender", "error");
    }
  };

  const column = [
    {
      headerName: "Vendor Name",
      field: "fullName",
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "e-Mail",
      field: "email",
      minWidth: 150,
      flex: 1,

      renderCell: (params) => {
        const info = params?.row?.merchantVendorsDetailsList[0];
        return (
          <>{info?.email}</>
        )
      }
    },
    {
      headerName: "Mobile Number",
      field: "merchantVendorsDetailsList[0].mobile",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const info = params?.row?.merchantVendorsDetailsList[0];
        return (
          <>
            {info?.mobile}</>
        )
      }
    },
    {
      headerName: "Category",
      field: "category",
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "Status",
      field: "vendorStatus",
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "Action",
      field: "viewDetails",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip title={params?.row?.enabled ? "Disable Vendor" : "Enable Vendor"}>
              <Switch
                checked={params?.row?.enabled}
                onChange={() => handleDisableVendor(params?.row?.vendorId, !params?.row?.enabled)}
                color="primary"
                size="small"
              />
            </Tooltip>
            <button
              className="border-0 bg-transparent ms-2"
              data-bs-toggle="modal"
              data-bs-target="#editVendorMobileNumber"
              onClick={() => {
                const _data = {
                  vendorId: params?.row?.id,
                  mobile: params?.row?.merchantVendorsDetailsList[0]?.mobile
                }
                setEditVendorData(_data)
              }}
            >
              <IconWrapper title={"Edit Vendor Mobile Number"}>
                <i class="fa-solid fa-pencil text-dark"></i>
              </IconWrapper>
            </button>
            <button
              className="border-0 bg-transparent ms-2"
              data-bs-toggle="modal"
              data-bs-target="#viewVendorBankDetails"
              onClick={() => fetchVendorAccountInfo(params?.row?.id)}
            >
              <IconWrapper title={"View Vendor Bank Details"}>
                <i class="fa-solid fa-building-columns text-dark"></i>
              </IconWrapper>
            </button>
            <button
              className="border-0 bg-transparent"
              data-bs-toggle="modal"
              data-bs-target="#ViewVendor"
              onClick={() => fetchVenderByVenderId(params?.row?.id)}
            >
              <IconWrapper title={"View Vendor Details"}>
                <i class="fa-solid fa-eye text-dark"></i>
              </IconWrapper>
            </button>
          </div >
        );
      },
    },
  ];

  const { hasPrivilagesSubmittedVendor, hasPrivilagesRegisterVendor } = CheckExportConst();

  return (
    // <div className="content-body">
    <div className="container-fluid">
      <div className="card">
        <div className="card-header p-3 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <h4 class="card-title">Vendors</h4>

          {hasPrivilagesRegisterVendor ? (
            <button
              className="btn btn-sm btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#registerVendor"
            >
              Register Vendor
            </button>
          ) : null}
        </div>

        <Modal id={"registerVendor"} title={"Register Vendor"} Width={"xl"}>
          <RegisterVendor
            setCallAgain={setCallAgain}
            callAgain={callAgain}
          />
        </Modal>

        <Modal id={"ViewVendor"} title={"View Vendor Details"} Width={"xl"}>
          <ViewVendor
            data={viewData}
            setEditVendorData={setEditVendorData}
          />
        </Modal>

        <Modal id={"editVendorBankDetails"} title={"Edit Vandor Bank Details"} Width={"xl"}>
          <EditVendorBankDetails
            data={editVendorData}
          />
        </Modal>

        <Modal id={"editVendorMobileNumber"} title={"Edit Vandor Mobile Number"} Width={"md"}>
          <EditVendorMobile
            data={editVendorData}
            setEditVendorData={setEditVendorData}
            refetchVendors={VenderByStatusWithMid}
          />
        </Modal>

        <Modal id={"viewVendorBankDetails"} title={"View Vandor Bank Details"} Width={"xl"}>
          <ViewVendorBankDetails
            data={vendorBankData}
          />
        </Modal>

        <div className="row">
          <div xs={12} lg={12} md={12} className="col">
            <div className="">
              <div className="">
                <div className="col">
                  {hasPrivilagesSubmittedVendor ? (
                    <div className={`mt-3 ${styles["DataGridHeight"]}`}>
                      {venderData?.length > 0 ? (
                        <DataGrid
                          rows={venderData}
                          columns={column}
                          slots={{
                            toolbar: GridToolbar,
                          }}
                          slotProps={{
                            toolbar: {
                              showQuickFilter: true,
                            },
                          }}
                          sx={{
                            "& .css-1rtad1": {
                              display: "block",
                            },
                          }}
                        />
                      ) : (
                        <NoDataFound />
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {/* ./card */}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default SubmittedVendor;